import { createContext, useContext } from 'react'

export interface FormControlState {
  isInvalid: boolean
}

const FormControlContext = createContext<FormControlState>({ isInvalid: false })
FormControlContext.displayName = 'FormControlContext'

export const FormControlProvider = FormControlContext.Provider
export function useFormControl(): FormControlState {
  const values = useContext(FormControlContext)

  return values
}
